import React, { useContext } from 'react'
import { SwissFarmerContext, getSwissFarmersFilters } from './SwissFarmerProviderComp'
import { ThemeContext } from 'styled-components'
import { Icon, Label } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { StyledFilterWrapper } from './style'

interface FilterValuesProps {
  dataFiltered: any
  handleChangeDataFiltered: (data: any) => void
}

const FilterValues: React.FC<FilterValuesProps> = (props) => {
  const { t } = useTranslation()
  const { dataFiltered, handleChangeDataFiltered } = props
  const { firstColor } = useContext(ThemeContext)
  const {
    contextValues,
    contextValues: {
      filterInputValues
    },
    setContextValues
  } = useContext(SwissFarmerContext)

  const filters = getSwissFarmersFilters()

  function renderFilterValues() {
    return Object.keys(filterInputValues).map(filterInputKey => {
      const filter = filters.find(f => f.key === filterInputKey)
      return dataFiltered[filterInputKey] !== '' && <Label key={filterInputKey} style={{ background: firstColor, color: 'white' }} as='a'>
        {`${t(filter?.placeholder)} (${dataFiltered[filterInputKey]})`}
        <Icon name='delete' onClick={() => {
          setContextValues({
            ...contextValues,
            filterInputValues: {
              ...contextValues.filterInputValues,
              [filterInputKey]: ''
            }
          })
        }} />
      </Label>
    })
  }

  return <StyledFilterWrapper>
    {renderFilterValues()}
  </StyledFilterWrapper>
}
export default FilterValues
